import { ENV } from "../utils";

export class Plantilla {
  baseApi = ENV.BASE_API;

  async getAll(accessToken, { activo, canal } = {}) {
    const params = new URLSearchParams();
    if (activo !== undefined) params.set("activo", activo);
    if (canal) params.set("canal", canal);
    const qs = params.toString() ? `?${params}` : "";
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PLANTILLAS}${qs}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async create(accessToken, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PLANTILLAS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 201) throw data;
    return data;
  }

  async update(accessToken, id, body) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PLANTILLAS}/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async toggle(accessToken, id) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PLANTILLAS}/${id}/toggle`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async remove(accessToken, id) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.PLANTILLAS}/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }
}
